/* eslint-disable jsx-a11y/anchor-is-valid */
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import { useEffect } from "react"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { __ } from "src/libs/utilities"

const CardFieldOuterLink = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    useEffect(() => {
            const height = getCssDemention(field.style?.height, "120px") 
            addCSSClass(
                `landing-card-field-outer-link-${section.id + "-" + value?.id}`,
                `.landing-card-field-outer-link-${section.id + "-" + value?.id} {
                    height: ${height}!important;
                    max-height: ${height}!important;
                } 
                `
            )
            return () => removeCSSClass(`landing-card-field-outer-link-${section.id + "-" + value?.id}`)
        }, []) 

    
    console.log(value)

    const style = { 
        ...field.style, 
        ...value.style 
    }
    style.backgroundColor = undefined
    return <div 
        className={`landing-card-field landing-card-field-outer-link landing-card-field-outer-link-${section.id + "-" + value.id}`} 
        style={ style } 
        data-card-field-id={i} 
        card-field-section-id={section.id}
    > 
        <a className="m-0" href={value?.data?.url} rel="noreferrer" target="_blank">
            <div 
                className={ `btn btn-primary ${props.field.className || ""} ` } 
                style={value?.data?.style}
            >
            {
                typeof value?.data?.label === "string"
                    ?
                    __(value?.data?.label)
                    :
                    value?.data?.label
            }    
            </div>
            
        </a>
    </div>
}
export default CardFieldOuterLink